// import type { Dispatch, SetStateAction } from "react";

// export interface AttachmentItem {
//   name: string;
//   size?: string;
//   url?: string;
//   [key: string]: any;
// }

// // Base constraint: any form object that might contain attachments or status
// export interface BaseFormData {
//   attachments?: any[];
//   status?: string;
//   [key: string]: any;
// }

// export interface ActionSidebarProps<T extends BaseFormData = BaseFormData> {
//   formData: T;
//   saving: boolean;
//   remark: string;
//   setRemark: Dispatch<SetStateAction<string>> | ((val: string) => void);
//   attachments?: AttachmentItem[];
//   onReturn: () => void | Promise<void>;
//   onReject: () => void | Promise<void>;
//   onApprove: () => void | Promise<void>;
//   onStartReview:()=> void | Promise<void>;
// }

// // Convert component to a generic function
// export const ActionSidebar = <T extends BaseFormData>({
//   formData,
//   saving,
//   remark,
//   setRemark,
//   attachments,
//   onReturn,
//   onApprove,
//   onStartReview
// }: ActionSidebarProps<T>) => {
//   const currentAttachments: AttachmentItem[] =
//     (formData.attachments as unknown as AttachmentItem[]) || attachments || [];

//   return (
//     <div className="space-y-6">
//       {/* Widget 1: Review Action Box */}
//       <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm space-y-4">
//         <h3 className="text-sm font-bold text-slate-900 border-b border-slate-100 pb-3 flex items-center gap-2">
//           <span>📋</span> စိစစ်ဆောင်ရွက်ရန်
//         </h3>

//         {/* 1. When status is SUBMITTED or missing: Show "Start Review" button */}
//           {(formData.status === 'SUBMITTED' || !formData.status) && (
//             <div className="space-y-3">
//               <div className="bg-amber-50 border border-amber-200 text-amber-800 p-2.5 rounded-lg text-xs font-medium flex items-center gap-2">
//                 <span>📩</span> လျှောက်လွှာတင်သွင်းထားပြီးပါပြီ။ စိစစ်မှုစတင်ရန် အောက်ပါခလုတ်ကို နှိပ်ပါ။
//               </div>
//               <button
//                 type="button"
//                 onClick={onStartReview} // Pass your handler function here (calls PATCH /documents/:id/under-review)
//                 disabled={saving}
//                 className="w-full py-2.5 px-4 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-xs font-bold shadow-sm transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-1.5"
//               >
//                 {saving ? (
//                   <>
//                     <span className="animate-spin">⏳</span>
//                     <span>ဆောင်ရွက်နေသည်...</span>
//                   </>
//                 ) : (
//                   <>
//                     <span>🔍</span>
//                     <span>စိစစ်မှုစတင်မည်</span>
//                   </>
//                 )}
//               </button>
//             </div>
//           )}

//           {/* 2. When status is UNDER_REVIEW: Show Remarks & Action Buttons (Return / Approve) */}
//           {formData.status === 'UNDER_REVIEW' && (
//             <div className="space-y-3">
//               <div className="bg-blue-50 border border-blue-200 text-blue-800 p-2.5 rounded-lg text-xs font-medium flex items-center gap-2">
//                 <span>✏️</span> ပြင်ဆင်စိစစ်ခြင်း ပြုလုပ်နိုင်ပါပြီ
//               </div>

//               <label className="text-xs font-medium text-slate-600 block">
//                 မှတ်ချက် / အကြောင်းကြားစာ
//               </label>
//               <textarea
//                 rows={3}
//                 value={remark}
//                 disabled={saving}
//                 onChange={(e) => setRemark(e.target.value)}
//                 placeholder="မှတ်ချက် သို့မဟုတ် ပြင်ဆင်ရန် အချက်များ ရေးသားပါ..."
//                 className="w-full text-xs p-2.5 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 disabled:bg-slate-100 disabled:cursor-not-allowed"
//               />

//               <div className="grid grid-cols-2 gap-2 pt-1">
//                 <button
//                   type="button"
//                   onClick={onReturn}
//                   disabled={saving}
//                   className="w-full py-2 px-3 bg-rose-50 hover:bg-rose-100 text-rose-700 rounded-lg text-xs font-bold border border-rose-200 transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-1.5"
//                 >
//                   {saving ? (
//                     <>
//                       <span className="animate-spin">⏳</span>
//                       <span>ဆောင်ရွက်နေသည်...</span>
//                     </>
//                   ) : (
//                     'ပြန်လည်ပြင်ဆင်ခိုင်းမည်'
//                   )}
//                 </button>
//                 <button
//                   type="button"
//                   onClick={onApprove}
//                   disabled={saving}
//                   className="w-full py-2 px-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-xs font-bold shadow-sm transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-1.5"
//                 >
//                   {saving ? (
//                     <>
//                       <span className="animate-spin">⏳</span>
//                       <span>ဆောင်ရွက်နေသည်...</span>
//                     </>
//                   ) : (
//                     'အတည်ပြုမည်'
//                   )}
//                 </button>
//               </div>
//             </div>
//           )}

//         {formData.status === 'APPROVED' && (
//           <div className="bg-emerald-50 border border-emerald-200 text-emerald-800 p-3 rounded-lg text-xs font-medium text-center">
//             ✓ ဤစာရွက်စာတမ်းအား အတည်ပြုပြီး ဖြစ်ပါသည်
//           </div>
//         )}

//         {formData.status === 'RETURNED' && (
//           <div className="bg-rose-50 border border-rose-200 text-rose-800 p-3 rounded-lg text-xs font-medium text-center">
//             ⚠️ ပြင်ဆင်ရန် မြို့နယ်သို့ ပြန်လည်အကြောင်းကြားထားသည်
//           </div>
//         )}
//       </div>

//       {/* Widget 2: Submitter Information */}
//       <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm space-y-3">
//         <h3 className="text-sm font-bold text-slate-900 border-b border-slate-100 pb-3 flex items-center gap-2">
//           <span>👤</span> ပေးပို့သူ အချက်အလက်
//         </h3>

//         <div className="space-y-2 text-xs">
//           <div className="flex justify-between py-1">
//             <span className="text-slate-500">အမည်:</span>
//             <span className="font-semibold text-slate-800">
//               {formData.signName || '-'}
//             </span>
//           </div>
//           <div className="flex justify-between py-1 border-t border-slate-100">
//             <span className="text-slate-500">ရာထူး:</span>
//             <span className="font-semibold text-slate-800">
//               အမှုလိုက်ဥပဒေအရာရှိ
//             </span>
//           </div>
//           <div className="flex justify-between py-1 border-t border-slate-100">
//             <span className="text-slate-500">ဌာန / ရုံး:</span>
//             <span className="font-semibold text-slate-800">
//               {formData.advocateOfficeName || '-'}
//             </span>
//           </div>
//           <div className="flex justify-between py-1 border-t border-slate-100">
//             <span className="text-slate-500">ပေးပို့သည့်ရက်:</span>
//             <span className="font-semibold text-slate-800">
//               {formData.submitDate || '-'}
//             </span>
//           </div>
//         </div>
//       </div>

//       {/* Widget 3: Signee Information */}
//       <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm space-y-3">
//         <h3 className="text-sm font-bold text-slate-900 border-b border-slate-100 pb-3 flex items-center gap-2">
//           <span>✍️</span> လက်မှတ်ရေးထိုးသူ
//         </h3>

//         <div className="flex items-center gap-3 pt-1">
//           <div className="w-12 h-12 rounded-lg bg-slate-100 border border-slate-200 flex items-center justify-center shrink-0 overflow-hidden">
//             {formData.signatureImage ? (
//               <img
//                 src={formData.signatureImage}
//                 alt="Signee"
//                 className="max-h-10 max-w-10 object-contain mix-blend-multiply"
//               />
//             ) : (
//               <span className="text-xs text-slate-400">✍️</span>
//             )}
//           </div>
//           <div>
//             <p className="text-xs font-bold text-slate-900">
//               {formData.signName || 'အမည် မရှိပါ'}
//             </p>
//             <p className="text-[11px] text-slate-500">
//               တွေ့ဆုံမေးမြန်းသူ အရာရှိ
//             </p>
//             {formData.signatureImage ? (
//               <span className="inline-block mt-1 text-[10px] bg-emerald-50 text-emerald-700 border border-emerald-200 px-1.5 py-0.5 rounded font-medium">
//                 ✓ လက်မှတ်ရေးထိုးပြီး
//               </span>
//             ) : (
//               <span className="inline-block mt-1 text-[10px] bg-amber-50 text-amber-700 border border-amber-200 px-1.5 py-0.5 rounded font-medium">
//                 ⏳ လက်မှတ်ရေးထိုးရန်ကျန်
//               </span>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Widget 4: Attachments Widget */}
//       <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm space-y-3">
//         <h3 className="text-sm font-bold text-slate-900 border-b border-slate-100 pb-3 flex items-center gap-2">
//           <span>📎</span> ပူးတွဲပါရှိသော စာရွက်စာတမ်းများ
//         </h3>

//         <div className="space-y-2">
//           {currentAttachments.length > 0 ? (
//             currentAttachments.map((file, idx) => (
//               <div
//                 key={idx}
//                 className="flex items-center justify-between p-2.5 rounded-lg border border-slate-100 bg-slate-50 hover:bg-slate-100/80 transition group"
//               >
//                 <div className="flex items-center gap-2 overflow-hidden">
//                   <span className="text-sm">📄</span>
//                   <div className="truncate">
//                     <p className="text-xs font-medium text-slate-700 truncate group-hover:text-blue-600">
//                       {file.name}
//                     </p>
//                     {file.size && (
//                       <p className="text-[10px] text-slate-400">{file.size}</p>
//                     )}
//                   </div>
//                 </div>
//                 {file.url && (
//                   <a
//                     href={file.url}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="text-xs text-blue-600 hover:underline shrink-0 font-medium ml-2"
//                   >
//                     ရယူမည်
//                   </a>
//                 )}
//               </div>
//             ))
//           ) : (
//             <p className="text-xs text-slate-400 italic text-center py-2">
//               ပူးတွဲဖိုင် မရှိပါ
//             </p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };


import type { Dispatch, SetStateAction } from "react";
import { useState } from "react";
import { AttachmentSection } from "./AttachmentSection";
import { openFileInNewTab } from "../../services/DocumentService";
import { GeoLevel } from "../../types/database";

const GEO_LEVEL_LABELS: Record<GeoLevel, string> = {
  [GeoLevel.NATIONAL]: "ရုံးချုပ် (National)",
  [GeoLevel.STATE]: "ပြည်နယ်/တိုင်း (State/Region)",
  [GeoLevel.DISTRICT]: "ခရိုင် (District)",
  [GeoLevel.TOWNSHIP]: "မြို့နယ် (Township)",
};
const GEO_LEVEL_ORDER = [
  GeoLevel.NATIONAL,
  GeoLevel.STATE,
  GeoLevel.DISTRICT,
  GeoLevel.TOWNSHIP,
];

interface CurrentUserContext {
  id?: string;
  officeId?: string;
  scopeLevel?: GeoLevel;
}

const getCurrentUserContext = (): CurrentUserContext | undefined => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    if (!user || typeof user !== "object") return undefined;

    return {
      id: user.id,
      officeId: user.officeId,
      scopeLevel: Object.values(GeoLevel).includes(user.scopeLevel)
        ? user.scopeLevel
        : undefined,
    };
  } catch (error) {
    console.error("Unable to read the current user's context:", error);
    return undefined;
  }
};

export interface AttachmentUser {
  id: string;
  name: string;
  email?: string;
  role?: string;
}

export interface AttachmentItem {
  id?: string;
  name?: string;
  fileName?: string;
  url?: string;
  fileUrl?: string;
  size?: string | number;
  fileSize?: number;
  createdAt?: string;
  uploadedBy?: AttachmentUser;
  [key: string]: any;
}

// Strictly map API Document response metadata alongside form values
export interface BaseFormData {
  id?: string;
  attachments?: AttachmentItem[];
  stageHistory?: {
    id?: string;
    action?: string;
    comments?: string;
    createdAt?: string;
    performedBy?: {
      id?: string;
      name?: string;
      role?: string;
      office?: {
        id?: string;
        name?: string;
      };
    };
  }[];
  status?: string;
  targetGeoLevels?: GeoLevel[] | string[] | string;
  originGeoLevel?: GeoLevel | string;
  createdAt?: string;
  submittedAt?: string;
  
  // API Document Metadata (The user & office who created/sent the document)
  createdBy?: {
    id?: string;
    name?: string;
    email?: string;
    role?: string;
  };
  originOffice?: {
    id?: string;
    name?: string;
  };

  // Form Fields (Form Inputs)
  signName?: string;
  advocateOfficeName?: string;
  signatureImage?: string;
  [key: string]: any;
}

export const isCurrentUserOrigin = (formData: BaseFormData): boolean => {
  const originUserId = formData.createdBy?.id || formData.createdById;
  return Boolean(originUserId && getCurrentUserContext()?.id === originUserId);
};

export interface ActionSidebarProps<T extends BaseFormData = BaseFormData> {
  formData: T;
  saving: boolean;
  remark: string;
  setRemark: Dispatch<SetStateAction<string>> | ((val: string) => void);
  attachments?: AttachmentItem[];
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveFile: (index: number) => void;
  onSave: (
    targetGeoLevels: GeoLevel[],
    forwardGeoLevels: GeoLevel[]
  ) => void | Promise<void>;
  onStartReview: () => void | Promise<void>;
}
export const ActionSidebar = <T extends BaseFormData>({
  formData,
  saving,
  remark,
  setRemark,
  attachments,
  onFileChange,
  onRemoveFile,
  onSave,
  onStartReview,
}: ActionSidebarProps<T>) => {
  const [selectedGeoLevels, setSelectedGeoLevels] = useState<GeoLevel[]>([]);
  const [currentUser] = useState(getCurrentUserContext);
  const isOriginUser = isCurrentUserOrigin(formData);
  const currentUserGeoLevel = currentUser?.scopeLevel;
  const targetGeoLevels = formData.targetGeoLevels;
  const configuredGeoLevels = Array.isArray(targetGeoLevels)
    ? targetGeoLevels
    : typeof targetGeoLevels === "string"
    ? targetGeoLevels.split(",").map((level) => level.trim())
    : [];
  const existingGeoLevels = Object.values(GeoLevel).filter((level) =>
    configuredGeoLevels.includes(level)
  );
  const currentLevelIndex = currentUserGeoLevel
    ? GEO_LEVEL_ORDER.indexOf(currentUserGeoLevel)
    : -1;
  const availableGeoLevels =
    currentLevelIndex > 0
      ? GEO_LEVEL_ORDER.slice(0, currentLevelIndex)
      : [];
  const levelsToSubmit = Array.from(
    new Set([...existingGeoLevels, ...selectedGeoLevels])
  );
  const currentUserHasReachedAttachmentStage = Boolean(
    currentUser?.id &&
      formData.stageHistory?.some((history: {
        action?: string;
        performedBy?: { id?: string };
      }) =>
        history.performedBy?.id === currentUser.id &&
        ["UNDER_REVIEW", "ATTACH", "ATTACHED"].includes(history.action || "")
      )
  );
  const forwardedByCurrentOffice =
    Boolean(formData.forwardedToLevels?.length) ||
    Boolean(
      formData.stageHistory?.some((history: {
        action?: string;
        performedBy?: {
          id?: string;
          office?: { id?: string };
        };
      }) => {
        if (history.action !== "FORWARD") return false;
        return (
          (currentUser?.officeId &&
            history.performedBy?.office?.id === currentUser.officeId) ||
          (currentUser?.id && history.performedBy?.id === currentUser.id)
        );
      })
    );
  const canDistrictAddAttachments =
    currentUserGeoLevel === GeoLevel.DISTRICT &&
    forwardedByCurrentOffice &&
    (formData.status === "SUBMITTED" || formData.status === "ATTACHED");

  const currentAttachments: AttachmentItem[] =
    (formData.attachments as unknown as AttachmentItem[]) || attachments || [];
  const savedAttachments = currentAttachments.filter(
    (file) => !(file instanceof File)
  );
  const commentHistory = (formData.stageHistory || []).filter(
    (history) => typeof history.comments === "string" && history.comments.trim()
  );

  // Format sent/submitted date in Myanmar format: ၃၀ အောက်တိုဘာ ၂၀၂၆
  const formatMyanmarDate = (value?: string) => {
    if (!value) return "-";

    const normalized = value.includes("T") ? value.split("T")[0] : value;
    const match = normalized.match(/^\d{4}-\d{2}-\d{2}$/);
    const date = match
      ? new Date(Number(match[0].slice(0, 4)), Number(match[0].slice(5, 7)) - 1, Number(match[0].slice(8, 10)))
      : new Date(value);

    if (Number.isNaN(date.getTime())) return "-";

    const monthNames = [
      "ဇန်နဝါရီ",
      "ဖေဖော်ဝါရီ",
      "မတ်",
      "ဧပြီ",
      "မေ",
      "ဇွန်",
      "ဇူလိုင်",
      "ဩဂုတ်",
      "စက်တင်ဘာ",
      "အောက်တိုဘာ",
      "နိုဝင်ဘာ",
      "ဒီဇင်ဘာ",
    ];

    const toMyanmarDigits = (input: string) =>
      input.replace(/\d/g, (digit) => "၀၁၂၃၄၅၆၇၈၉"[Number(digit)]);

    const day = toMyanmarDigits(String(date.getDate()).padStart(2, "0"));
    const month = monthNames[date.getMonth()];
    const year = toMyanmarDigits(String(date.getFullYear()));

    return `${day}-${month}-${year}`;
  };

  const sentDateRaw = formData.submittedAt || formData.createdAt;
  const formattedSentDate = formatMyanmarDate(sentDateRaw);

  // Helper function to safely view documents in a new window/tab
  // const handleView = (e: React.MouseEvent, url: string) => {
  //   e.preventDefault();
  //   e.stopPropagation();

  //   // Open file directly in a clean new tab
  //   const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  //   if (newWindow) {
  //     newWindow.opener = null;
  //   }
  // };

  // Helper function to force file download safely without page reload
  const handleDownload = async (
    e: React.MouseEvent<HTMLButtonElement>,
    url: string,
    filename: string
  ) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="space-y-6">
      {/* Widget 1: Review Action Box */}
      <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm space-y-4">
        <h3 className="text-sm font-bold text-slate-900 border-b border-slate-100 pb-3 flex items-center gap-2">
          <span>📋</span>  ပြင်ဆင်ချက်/ညွှန်ကြားချက်
        </h3>

        {/* 1. Status SUBMITTED */}
        {!isOriginUser &&
          (formData.status === "SUBMITTED" || !formData.status) &&
          !currentUserHasReachedAttachmentStage &&
          !canDistrictAddAttachments && (
          <div className="space-y-3">
            <div className="bg-amber-50 border border-amber-200 text-amber-800 p-2.5 rounded-lg text-xs font-medium flex items-center gap-2">
              <span>📩</span> လျှောက်လွှာရောက်ရှိကြောင်းအကြောင်းကြားရန် အောက်ပါခလုတ်ကို နှိပ်ပါ။
            </div>
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                onStartReview();
              }}
              disabled={saving}
              className="w-full py-2.5 px-4 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-xs font-bold shadow-sm transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-1.5"
            >
              {saving ? (
                <>
                  <span className="animate-spin">⏳</span>
                  <span>ဆောင်ရွက်နေသည်...</span>
                </>
              ) : (
                <>
                  <span>🔍</span>
                  <span>‌ကြည့်ရှုကြောင်း အကြောင်းကြားမည်</span>
                </>
              )}
            </button>
          </div>
        )}

        {/* 2. Status UNDER_REVIEW */}
        {!isOriginUser &&
          (formData.status === "UNDER_REVIEW" ||
          formData.status === "ATTACHED" ||
          canDistrictAddAttachments ||
          currentUserHasReachedAttachmentStage) && (
          <div className="space-y-3">
            {canDistrictAddAttachments ? (
              <div className="bg-emerald-50 border border-emerald-200 text-emerald-800 p-2.5 rounded-lg text-xs font-medium flex items-center gap-2">
                <span>📎</span> အထက်အဆင့်သို့ တင်ပြပြီးဖြစ်သော်လည်း ပူးတွဲဖိုင်နှင့် မှတ်ချက်များ ထပ်မံပေးပို့နိုင်ပါသည်
              </div>
            ) : formData.status === "UNDER_REVIEW" ? (
              <div className="bg-blue-50 border border-blue-200 text-blue-800 p-2.5 rounded-lg text-xs font-medium flex items-center gap-2">
                <span>✏️</span> ပြင်ဆင်စိစစ်ခြင်း ပြုလုပ်နိုင်ပါပြီ
              </div>
            ) : (
              <div className="bg-emerald-50 border border-emerald-200 text-emerald-800 p-2.5 rounded-lg text-xs font-medium flex items-center gap-2">
                <span>📎</span> ပူးတွဲဖိုင်နှင့် မှတ်ချက်များ ထပ်မံပေးပို့နိုင်ပါသည်
              </div>
            )}

            <label className="text-xs font-medium text-slate-600 block">
              မှတ်ချက် / အကြောင်းကြားစာ
            </label>
            <textarea
              rows={3}
              value={remark}
              disabled={saving}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="မှတ်ချက် သို့မဟုတ် ပြင်ဆင်ရန် အချက်များ ရေးသားပါ..."
              className="w-full text-xs p-2.5 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 disabled:bg-slate-100 disabled:cursor-not-allowed"
            />

            {!canDistrictAddAttachments && availableGeoLevels.length > 0 && (
              <div className="flex flex-col gap-2 bg-slate-50 p-3 rounded-lg border border-slate-200">
                <span className="text-xs font-semibold text-slate-700">
                  ထပ်မံတင်ပြလိုသည့် အဆင့်များ ရွေးချယ်ပါ:
                </span>
                <div className="flex flex-wrap items-center gap-2">
                  {availableGeoLevels.map((level) => {
                    const isExisting = existingGeoLevels.includes(level);
                    const isChecked =
                      isExisting || selectedGeoLevels.includes(level);

                    return (
                      <label
                        key={level}
                        className={`flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-md border transition-colors ${
                          isExisting
                            ? "border-slate-300 bg-slate-200/60 text-slate-500 opacity-60 cursor-not-allowed select-none"
                            : isChecked
                            ? "border-blue-500 bg-blue-50 text-blue-700 font-semibold cursor-pointer"
                            : "border-slate-300 bg-white text-slate-600 hover:bg-slate-100 cursor-pointer"
                        }`}
                      >
                        <input
                          type="checkbox"
                          value={level}
                          checked={isChecked}
                          onChange={() =>
                            setSelectedGeoLevels((current) =>
                              current.includes(level)
                                ? current.filter((selected) => selected !== level)
                                : [...current, level]
                            )
                          }
                          disabled={saving || isExisting}
                          className="w-3.5 h-3.5 text-blue-600 focus:ring-blue-500 border-slate-300 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        />
                        {GEO_LEVEL_LABELS[level]}
                        {isExisting && (
                          <span className="text-[10px] text-slate-400 ml-0.5">(တင်ပြပြီး)</span>
                        )}
                      </label>
                    );
                  })}
                </div>
              </div>
            )}

            <div className="pt-1">
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  onSave(levelsToSubmit, selectedGeoLevels);
                }}
                disabled={saving}
                className="w-full py-2.5 px-4 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-xs font-bold shadow-sm transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-1.5"
              >
                {saving ? (
                  <>
                    <span className="animate-spin">⏳</span>
                    <span>ဆောင်ရွက်နေသည်...</span>
                  </>
                ) : (
                  <>
                    <span>💾</span>
                    <span>
                      {formData.status === "ATTACHED"
                        ? "ပူးတွဲဖိုင်/ညွှန်ကြားချက် ထပ်မံပေးပို့မည်"
                        : canDistrictAddAttachments
                        ? "ပူးတွဲဖိုင်/ညွှန်ကြားချက် ထပ်မံပေးပို့မည်"
                        : "ညွှန်ကြားချက် ပေးပို့မည်"}
                    </span>
                  </>
                )}
              </button>
            </div>
            <AttachmentSection
              attachments={currentAttachments}
              isEditable={
                !isOriginUser &&
                (formData.status === "UNDER_REVIEW" ||
                formData.status === "ATTACHED" ||
                canDistrictAddAttachments ||
                currentUserHasReachedAttachmentStage)
              }
              canAddAttachments={
                !isOriginUser &&
                (formData.status === "UNDER_REVIEW" ||
                formData.status === "ATTACHED" ||
                canDistrictAddAttachments ||
                currentUserHasReachedAttachmentStage)
              }
              isPreview={false}
              onFileChange={onFileChange}
              onRemoveFile={onRemoveFile}
            />
          </div>
        )}

      </div>

      

      {/* Widget 2: Submitter Information */}
      <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm space-y-3">
        <h3 className="text-sm font-bold text-slate-900 border-b border-slate-100 pb-3 flex items-center gap-2">
          <span>👤</span> ပေးပို့သူ အချက်အလက်
        </h3>

        <div className="space-y-2 text-xs">
          <div className="flex justify-between py-1">
            <span className="text-slate-500">အမည်:</span>
            <span className="font-semibold text-slate-800">
              {formData.createdBy?.name || "-"}
            </span>
          </div>
          <div className="flex justify-between py-1 border-t border-slate-100">
            <span className="text-slate-500">ရာထူး:</span>
            <span className="font-semibold text-slate-800">
              {formData.createdBy?.role || "-"}
            </span>
          </div>
          <div className="flex justify-between py-1 border-t border-slate-100">
            <span className="text-slate-500">ဌာန / ရုံး:</span>
            <span className="font-semibold text-slate-800">
              {formData.originOffice?.name || "-"}
            </span>
          </div>
          <div className="flex justify-between py-1 border-t border-slate-100">
            <span className="text-slate-500">ပေးပို့သည့်ရက်:</span>
            <span className="font-semibold text-slate-800">
              {formattedSentDate}
            </span>
          </div>
        </div>
      </div>

      {/* Widget 4: Attachments List */}
      <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm space-y-3">
        <h3 className="text-sm font-bold text-slate-900 border-b border-slate-100 pb-3 flex items-center gap-2">
          <span>📎</span> ပြင်ဆင်ချက်/ညွှန်ကြားချက် စာရွက်စာတမ်းများ
        </h3>

        <div className="space-y-2.5">
          {savedAttachments.length > 0 ? (
            savedAttachments.map((file, idx) => {
              const fileName = file.fileName || file.name || "အမည်မသိ ဖိုင်";
              const fileUrl = file.fileUrl || file.url;
              const uploaderName = file.uploadedBy?.name || "-";
              const uploaderRole = file.uploadedBy?.role;

              return (
                <div
                  key={file.id || idx}
                  className="p-3 rounded-lg border border-slate-200 bg-slate-50 hover:bg-slate-100/80 transition space-y-2"
                >
                  <div className="flex items-start justify-between gap-2">
                    <div className="flex items-center gap-2 overflow-hidden">
                      <span className="text-base shrink-0">📄</span>
                      <div className="truncate">
                        <p
                          className="text-xs font-semibold text-slate-800 truncate"
                          title={fileName}
                        >
                          {fileName}
                        </p>
                        {file.size && (
                          <p className="text-[10px] text-slate-400">
                            {file.size}
                          </p>
                        )}
                      </div>
                    </div>

                    {fileUrl && (
                      <div className="flex items-center gap-1.5 shrink-0">
                        {/* View Button - Changed to explicit button with event isolation */}
                        <button
                          type="button"
                          title="ကြည့်ရှုမည်"
                          onClick={() => openFileInNewTab(fileUrl)}
                          className="text-xs text-slate-600 hover:text-slate-900 bg-white hover:bg-slate-200 px-2 py-1 rounded border border-slate-200 transition font-medium flex items-center gap-1 shadow-xs cursor-pointer"
                        >
                          <span>👁️</span>
                          <span>ကြည့်မည်</span>
                        </button>

                        {/* Download Button */}
                        <button
                          type="button"
                          title="ရယူမည်"
                          onClick={(e) => handleDownload(e, fileUrl, fileName)}
                          className="text-xs text-blue-600 hover:text-blue-800 bg-blue-50 hover:bg-blue-100 px-2 py-1 rounded border border-blue-200 transition font-medium flex items-center gap-1 shadow-xs cursor-pointer"
                        >
                          <span>📥</span>
                          <span>ရယူမည်</span>
                        </button>
                      </div>
                    )}
                  </div>

                  <div className="flex items-center justify-between text-[11px] text-slate-500 pt-1 border-t border-slate-200/60">
                    <span className="flex items-center gap-1">
                      <span className="text-slate-400">ညွှန်ကြားချက်ပေးပို့သူ:</span>
                      <span className="font-semibold text-slate-700">
                        {uploaderName}
                      </span>
                      {uploaderRole && (
                        <span className="text-[10px] text-slate-400">
                          ({uploaderRole})
                        </span>
                      )}
                    </span>
                    {file.createdAt && (
                      <span className="text-[10px] text-slate-400">
                        {formatMyanmarDate(file.createdAt)}
                      </span>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <p className="text-xs text-slate-400 italic text-center py-2">
              ပူးတွဲဖိုင် မရှိပါ
            </p>
          )}
        </div>
      </div>

      {commentHistory.length > 0 && (
        <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm space-y-3">
          <h3 className="text-sm font-bold text-slate-900 border-b border-slate-100 pb-3 flex items-center gap-2">
            <span>💬</span> မှတ်ချက် / အကြောင်းကြားစာများ
          </h3>

          <div className="space-y-2.5">
            {commentHistory.map((history, index) => (
              <div
                key={history.id || `${history.createdAt || "comment"}-${index}`}
                className="rounded-lg border border-slate-200 bg-slate-50 p-3 space-y-1.5"
              >
                <div className="flex items-start justify-between gap-2 text-[11px] text-slate-500">
                  <span className="font-semibold text-slate-700">
                    {history.performedBy?.name ||
                      history.performedBy?.office?.name ||
                      "အသုံးပြုသူ"}
                    {history.performedBy?.role && ` (${history.performedBy.role})`}
                  </span>
                  {history.createdAt && (
                    <span className="shrink-0">
                      {formatMyanmarDate(history.createdAt)}
                    </span>
                  )}
                </div>
                <p className="text-xs text-slate-700 whitespace-pre-wrap break-words">
                  {history.comments}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};